import { permissions } from '@/plugins/acl'
import api from '@/services/api'

export default {
  getAll: {
    permission: permissions.upgradeView,
    request: ({ params }) => api.get('/upgrades', params)
  }
}
